/* ============================================================================
   assets/ll-preorder-hub.js
   The behaviour for sections/ll-preorder-hub.liquid.
   ============================================================================

   This used to be an inline <script> in the section. Inline meant it was part
   of the HTML document: re-rendered by Shopify and re-sent to the browser on
   every single page view, never cached, and counted against the time the
   server spends building the page. On the homepage the six hub sections came
   to 127 KB of the 1.8 MB document.

   The code is byte-identical on every render, so it belongs in an asset the
   browser can cache once and reuse across the whole site.

   WHAT CHANGED, AND WHAT DID NOT. The section used to bake its own id into the
   script as `var ROOT_ID = "{{ uid }}"`, which is the single reason this could
   not be a static file. One asset now serves every instance: it finds each
   root by its [data-llpo-root] marker and reads the id from
   data-section-id, which the markup already carried. Everything inside
   initInstance is the original code, unchanged.

   The per-instance JSON config block stays in the section, because that is
   real per-instance data rather than code.
============================================================================ */
(function () {
  /* Two instances of the same section put two identical <script src> tags on
     the page, and the browser runs both. */
  if (window.__llPreorderHubJS) return;
  window.__llPreorderHubJS = true;

  /* ---- block 1 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      function boot(root) {
          if (!root || root.dataset.llpoReady === '1') return;
          root.dataset.llpoReady = '1';

          var cfgEl = root.querySelector('[data-llpo-config]');
          var cfg = {};
          try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
          cfg.labels = cfg.labels || {};
          cfg.cardLabels = cfg.cardLabels || {};
          cfg.cta = cfg.cta || {};
          cfg.cdLabels = cfg.cdLabels || {};
          cfg.cdMiniLabels = cfg.cdMiniLabels || {};

          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var live = root.querySelector('[data-live-region]');
          var timers = [];
          var observers = [];

          function say(msg) { if (live) live.textContent = msg; }
          function num(el, attr) { var v = parseInt(el.getAttribute(attr), 10); return isNaN(v) ? 0 : v; }

          /* =====================================================================
             TOAST
          ===================================================================== */
          var toast = root.querySelector('[data-toast]');
          var toastText = root.querySelector('[data-toast-text]');
          var toastLink = root.querySelector('[data-toast-link]');
          var toastTimer = null;
          function showToast(msg, href, linkText) {
            if (!toast) return;
            toastText.textContent = msg;
            if (href) {
              toastLink.href = href;
              toastLink.textContent = linkText || 'View cart';
              toastLink.hidden = false;
              toastLink.target = href.indexOf('discord') > -1 ? '_blank' : '';
            } else {
              toastLink.hidden = true;
            }
            toast.classList.add('is-on');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
            say(msg);
          }

          /* =====================================================================
             WATCHLIST  (shared with TCG + plush hubs)
          ===================================================================== */
          var WKEY = 'll_watchlist';
          var WKEY_LEGACY = 'll_preorder_watch';
          function readWatch() {
            try {
              var list = JSON.parse(localStorage.getItem(WKEY) || 'null');
              if (Object.prototype.toString.call(list) === '[object Array]') return list;
              var old = JSON.parse(localStorage.getItem(WKEY_LEGACY) || '[]') || [];
              if (Object.prototype.toString.call(old) === '[object Array]' && old.length) {
                writeWatch(old);
                return old;
              }
            } catch (e) {}
            return [];
          }
          function writeWatch(list) {
            try {
              var clean = (list || []).slice(0, 100);
              localStorage.setItem(WKEY, JSON.stringify(clean));
              localStorage.setItem(WKEY_LEGACY, JSON.stringify(clean));
              var cid = root.getAttribute('data-customer-id');
              if (cid) localStorage.setItem('ll_watchlist_c_' + cid, JSON.stringify(clean));
              try {
                document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } }));
              } catch (e2) {}
              return clean;
            } catch (e) { return list || []; }
          }
          function unwatchHandle(handle) {
            var list = readWatch().filter(function (h) { return h !== handle; });
            writeWatch(list);
            try {
              var snaps = JSON.parse(localStorage.getItem('ll_watchlist_snap') || '{}') || {};
              delete snaps[handle];
              localStorage.setItem('ll_watchlist_snap', JSON.stringify(snaps));
            } catch (e) {}
            if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') {
              window.LLWatchlistLive.stop(handle);
            }
            return list;
          }
          var watchChip = root.querySelector('[data-watch-chip]');
          var watchCount = root.querySelector('[data-watch-count]');
          var watchOnly = false;

          function paintWatch() {
            var list = readWatch();
            root.querySelectorAll('[data-card]').forEach(function (card) {
              var bell = card.querySelector('[data-watch]');
              if (!bell) return;
              var on = list.indexOf(card.getAttribute('data-handle')) > -1;
              bell.setAttribute('aria-pressed', on ? 'true' : 'false');
              /* The bell kept saying "Watch ..." after it had been saved, so the only
                 feedback was a colour change. State what it will do next. */
              var lab = bell.getAttribute(on ? 'data-watch-remove' : 'data-watch-add');
              if (lab) { bell.setAttribute('aria-label', lab); bell.setAttribute('title', lab); }

              /* The "Watch for alerts" button is the primary control on a coming-soon
                 card, so its VISIBLE text has to flip too - not just the bell. */
              var cta = card.querySelector('[data-watch-cta]');
              if (cta) {
                var t = cta.querySelector('[data-cta-text]');
                var next = cta.getAttribute(on ? 'data-watch-remove' : 'data-watch-add');
                if (t && next) t.textContent = next;
                cta.setAttribute('aria-pressed', on ? 'true' : 'false');
              }
            });
            if (watchChip) {
              watchChip.hidden = list.length === 0;
              watchChip.setAttribute('data-has', list.length ? '1' : '0');
              if (watchCount) watchCount.textContent = list.length;
              if (!list.length) {
                watchOnly = false;
                watchChip.setAttribute('aria-pressed', 'false');
              }
            }
            if (typeof applyFilter === 'function') applyFilter();
          }

          root.addEventListener('click', function (e) {
            var watchCta = e.target.closest('[data-watch-cta]');
            if (watchCta && root.contains(watchCta)) {
              e.preventDefault();
              var card = watchCta.closest('[data-card]');
              var bell = card && card.querySelector('[data-watch]');
              if (bell) bell.click();
              return;
            }
            var bell = e.target.closest('[data-watch]');
            if (!bell || !root.contains(bell)) return;
            e.preventDefault();
            var card = bell.closest('[data-card]');
            var handle = card.getAttribute('data-handle');
            var list = readWatch();
            var at = list.indexOf(handle);
            if (at > -1) {
              unwatchHandle(handle); paintWatch();
              /* Removing used to announce to screen readers only - a sighted shopper
                 got nothing. showToast() hides the link when href is empty, so the
                 last removal does not point at an empty watchlist. */
              var msg = cfg.toastWatchRemoved || 'Removed from your watchlist';
              showToast(msg, readWatch().length ? (cfg.watchUrl || '/pages/watchlist') : '',
                        cfg.watchLinkLabel || 'View watchlist');
            } else {
              list.unshift(handle);
              writeWatch(list); paintWatch();
              /* Theme editor may still hold the old Discord toast copy; never surface it. */
              var watchMsg = cfg.toastWatch || 'Added to your watchlist';
              if (/discord|drop ping/i.test(String(watchMsg))) watchMsg = 'Added to your watchlist';
              var watchHref = cfg.watchUrl || '/pages/watchlist';
              if (/discord/i.test(String(watchHref))) watchHref = '/pages/watchlist';
              var watchLink = cfg.watchLinkLabel || 'View watchlist';
              if (/discord/i.test(String(watchLink))) watchLink = 'View watchlist';
              showToast(watchMsg, watchHref, watchLink);
            }
          });

          var K_TIP = 'll_watchlist_tip_seen';
          var tipEl = root.querySelector('[data-watch-tip]');
          var tipDismiss = root.querySelector('[data-watch-tip-dismiss]');
          function tipSeen() {
            try { return localStorage.getItem(K_TIP) === '1'; } catch (e) { return true; }
          }
          function hideAllTips() {
            document.querySelectorAll('[data-watch-tip]').forEach(function (el) { el.hidden = true; });
          }
          function markTipSeen() {
            try { localStorage.setItem(K_TIP, '1'); } catch (e) {}
            hideAllTips();
            try { document.dispatchEvent(new CustomEvent('ll:watchlist:tip-dismissed')); } catch (e) {}
          }
          if (tipEl && !tipSeen()) tipEl.hidden = false;
          if (tipDismiss) tipDismiss.addEventListener('click', markTipSeen);
          document.addEventListener('ll:watchlist:tip-dismissed', hideAllTips);

          function syncWatchFromStore() {
            paintWatch();
          }
          function onWatchStorage(ev) {
            if (!ev || !ev.key) return;
            if (ev.key === K_TIP && ev.newValue === '1') hideAllTips();
            if (ev.key === WKEY || ev.key === WKEY_LEGACY || (ev.key.indexOf && ev.key.indexOf('ll_watchlist_c_') === 0)) {
              syncWatchFromStore();
            }
          }
          document.addEventListener('ll:watchlist:change', syncWatchFromStore);
          window.addEventListener('storage', onWatchStorage);

          if (watchChip) {
            watchChip.addEventListener('click', function () {
              watchOnly = !watchOnly;
              watchChip.setAttribute('aria-pressed', watchOnly ? 'true' : 'false');
              applyFilter();
              say(watchOnly ? 'Showing watched drops only' : 'Showing all drops');
            });
          }

          /* =====================================================================
             TABS  (real ARIA tabs; the section accent follows the active game)
          ===================================================================== */
          var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
          var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

          function activate(index, focusTab) {
            tabs.forEach(function (t, i) {
              var on = i === index;
              t.setAttribute('aria-selected', on ? 'true' : 'false');
              t.setAttribute('tabindex', on ? '0' : '-1');
              if (on && focusTab) t.focus();
              if (on) {
                root.style.setProperty('--acc', t.getAttribute('data-acc'));
                root.style.setProperty('--acc2', t.getAttribute('data-acc2'));
                root.style.setProperty('--acc-ink', t.getAttribute('data-acc-ink'));
                root.style.setProperty('--on-acc', t.getAttribute('data-on-acc'));
                t.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
              }
            });
            panels.forEach(function (p, i) { p.hidden = i !== index; });
            showSetRow(index);
            clearSet();
            clearDate();
            syncViewAll();
            refreshChips();
            applyFilter();
            applySort();
            refreshRails();
            var label = panels[index] ? panels[index].getAttribute('data-label') : '';
            say(label ? label + ' drops shown' : '');
          }

          tabs.forEach(function (t, i) {
            t.addEventListener('click', function () { activate(i, false); });
            t.addEventListener('keydown', function (e) {
              var k = e.key, next = null;
              if (k === 'ArrowRight') next = (i + 1) % tabs.length;
              else if (k === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
              else if (k === 'Home') next = 0;
              else if (k === 'End') next = tabs.length - 1;
              if (next !== null) { e.preventDefault(); activate(next, true); }
            });
          });

          function activePanel() {
            for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) return panels[i]; }
            return panels[0] || root;
          }

          /* =====================================================================
             FILTER + SORT
          ===================================================================== */
          var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
          var filter = 'all';
          /* A drop schedule chip narrows the grid to one release date. '' is off.
             It stacks with the status chips rather than replacing them, so the
             status counts below are always counted inside the chosen date. */
          var dateFilter = '';
          var dateLabel = '';
          /* A set chip narrows the tab to one set, read from the card's tags. ''
             is every set. It stacks with the date and the status in the same way
             the date does, so every count below is counted inside the set. */
          var setFilter = '';
          var setLabel = '';

          /* Chips carry the live count for the active tab. A status with nothing in
             it is disabled, so "Allocation pending" can never be clicked into an
             empty grid — and if the active tab has none of the current status, the
             filter falls back to All rather than showing nothing. */
          function refreshChips() {
            var panel = activePanel();
            if (!panel || !chips.length) return;
            /* Include featured hero: with hide_featured_in_grid it is often the only copy. */
            var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-card]')).filter(inScope);
            var counts = { all: cards.length, live: 0, coming: 0, pending: 0, released: 0, soldout: 0 };
            cards.forEach(function (c) {
              var st = c.getAttribute('data-state');
              if (counts[st] !== undefined) counts[st]++;
            });
            var reset = false;
            chips.forEach(function (chip) {
              var key = chip.getAttribute('data-filter');
              var n = counts[key] || 0;
              var out = chip.querySelector('[data-chip-n]');
              if (out) out.textContent = n ? ' ' + n : '';
              var off = key !== 'all' && n === 0;
              chip.disabled = off;
              if (off && filter === key) reset = true;
            });
            if (reset) filter = 'all';
            chips.forEach(function (chip) {
              chip.setAttribute('aria-pressed', chip.getAttribute('data-filter') === filter ? 'true' : 'false');
            });
          }

          /* Scope is the chosen set and the chosen date, both optional. */
          function inSet(card) {
            if (!setFilter) return true;
            return (' ' + (card.getAttribute('data-sets') || '') + ' ').indexOf(' ' + setFilter + ' ') > -1;
          }
          function inScope(card) {
            if (!inSet(card)) return false;
            if (!dateFilter) return true;
            return card.getAttribute('data-relkey') === dateFilter;
          }

          function applyFilter() {
            var panel = activePanel();
            if (!panel) return;
            var watched = readWatch();
            var shown = 0;
            panel.querySelectorAll('.llpo__card').forEach(function (card) {
              var st = card.getAttribute('data-state');
              var ok = (filter === 'all') || (st === filter);
              if (ok) ok = inScope(card);
              if (ok && watchOnly) ok = watched.indexOf(card.getAttribute('data-handle')) > -1;
              card.hidden = !ok;
              if (ok) shown++;
            });
            /* Featured lives outside the grid (hide_featured_in_grid). Status chips leave
               it pinned; Watching must include or hide it so the empty state is honest. */
            var hero = panel.querySelector('[data-featured][data-card]');
            if (hero) {
              var hOk = !watchOnly || watched.indexOf(hero.getAttribute('data-handle')) > -1;
              if (hOk) hOk = inScope(hero);
              hero.hidden = !hOk;
              if (hOk) shown++;
            }
            var none = panel.querySelector('[data-no-results]');
            if (none) {
              none.setAttribute('data-show', shown === 0 ? '1' : '0');
              var title = none.querySelector('h4');
              var copy = none.querySelector('p');
              if (title && copy) {
                if (watchOnly && shown === 0) {
                  title.textContent = 'No watched drops here';
                  copy.textContent = 'Your saved items may be on another game tab, or open your full watchlist.';
                } else if (dateFilter && shown === 0) {
                  title.textContent = 'Nothing on ' + dateLabel + ' matches that status';
                  copy.textContent = 'Try another status, or press that date again to see every drop.';
                } else {
                  title.textContent = 'Nothing matches that filter';
                  copy.textContent = 'Try another status, or open your watchlist for saved drops.';
                }
              }
            }
          }

          chips.forEach(function (chip) {
            chip.addEventListener('click', function () {
              if (chip.disabled) return;
              filter = chip.getAttribute('data-filter');
              chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
              applyFilter();
              var g = activePanel() ? activePanel().querySelector('[data-grid]') : null;
              if (g) g.scrollLeft = 0;
              refreshRails();
            });
          });

          var sortSel = root.querySelector('[data-sort]');
          function buyable(card) {
            var st = card.getAttribute('data-state');
            return st === 'live' || st === 'released';
          }
          function applySort() {
            var panel = activePanel();
            if (!panel) return;
            var grid = panel.querySelector('[data-grid]');
            if (!grid) return;
            var mode = sortSel ? sortSel.value : (cfg.defaultSort || 'release');
            var cards = Array.prototype.slice.call(grid.querySelectorAll('.llpo__card'));
            cards.sort(function (a, b) {
              /* Available now first: a drop with stock to buy today, whether a live
                 pre-order or released and in stock, leads; then the newest listing.
                 Read from data-state, which the countdown keeps current, so a drop
                 that opens for pre-order while the page is open moves up with it. */
              if (mode === 'available') {
                var aa = buyable(a) ? 0 : 1, ab = buyable(b) ? 0 : 1;
                if (aa !== ab) return aa - ab;
                var na = num(b, 'data-new') - num(a, 'data-new');
                if (na) return na;
                return (num(a, 'data-rel') || 9999999999) - (num(b, 'data-rel') || 9999999999);
              }
              if (mode === 'price_asc' || mode === 'price_desc') {
                var pa = num(a, 'data-price'), pb = num(b, 'data-price');
                return mode === 'price_asc' ? pa - pb : pb - pa;
              }
              var ra = num(a, 'data-rel') || 9999999999;
              var rb = num(b, 'data-rel') || 9999999999;
              return mode === 'release_desc' ? rb - ra : ra - rb;
            });
            cards.forEach(function (c) { grid.appendChild(c); });
          }
          if (sortSel) {
            if (cfg.defaultSort) sortSel.value = cfg.defaultSort;
            sortSel.addEventListener('change', applySort);
          }

          /* =====================================================================
             STATE MACHINE  —  countdown keeps every card honest
          ===================================================================== */
          function stateFor(card, available) {
            var rel = num(card, 'data-rel');
            var reveal = num(card, 'data-reveal');
            var now = Math.floor(Date.now() / 1000);
            if (!rel) return available ? 'live' : 'pending';
            if (now >= rel) return available ? 'released' : 'soldout';
            if (available) return 'live';
            return now < reveal ? 'coming' : 'pending';
          }

          function buildCta(card, state) {
            var old = card.querySelector('[data-cta]');
            if (!old) return;
            var hero = card.hasAttribute('data-featured');
            var multi = card.getAttribute('data-multi') === 'true';
            var url = card.getAttribute('data-url');
            var buyable = state === 'live' || state === 'released';
            var el;

            if (buyable && !multi) {
              el = document.createElement('button');
              el.type = 'button';
              el.setAttribute('data-add', '');
              el.className = 'llpo__btn llpo__btn--primary';
              el.innerHTML = '<span class="llpo__spin" aria-hidden="true"></span>' +
                '<span class="llpo__btn-txt" data-cta-text></span>';
            } else if (buyable) {
              el = document.createElement('a');
              el.href = url;
              el.className = 'llpo__btn llpo__btn--primary';
              el.innerHTML = '<span class="llpo__btn-txt" data-cta-text></span>';
            } else {
              el = document.createElement('button');
              el.type = 'button';
              el.setAttribute('data-watch-cta', '');
              el.className = 'llpo__btn ' + (hero ? 'llpo__btn--ghost' : 'llpo__btn--ghost');
              el.innerHTML = '<span class="llpo__btn-txt" data-cta-text></span>';
            }
            el.setAttribute('data-cta', '');
            var txt = el.querySelector('[data-cta-text]');
            if (txt) {
              if (buyable && multi) txt.textContent = state === 'live' ? (cfg.cta.live || 'Pre-order') : 'Choose options';
              else txt.textContent = cfg.cta[state] || '';
            }
            old.parentNode.replaceChild(el, old);
          }

          var announced = {};
          function applyState(card, state, available) {
            var prev = card.getAttribute('data-state');
            if (prev === state) return false;
            card.setAttribute('data-state', state);
            card.setAttribute('data-avail', available ? 'true' : 'false');

            var hero = card.hasAttribute('data-featured');
            var pill = card.querySelector('[data-state-pill]');
            if (pill) {
              pill.setAttribute('data-state', state);
              var pt = pill.querySelector('[data-state-text]');
              if (pt) pt.textContent = (hero ? cfg.labels[state] : cfg.cardLabels[state]) || state;
            }

            /* The meter only exists once there is an allocation to report — it stays
               hidden through Coming Soon and appears when the window opens. */
            var allocBox = card.querySelector('[data-alloc]');
            if (allocBox) allocBox.hidden = (state === 'coming');

            var alloc = card.querySelector('[data-alloc-label]');
            var fill = card.querySelector('[data-alloc-fill]');
            if (state === 'pending') {
              if (alloc) alloc.textContent = hero ? 'Allocation pending' : 'Pending';
              if (fill) { fill.setAttribute('data-pending', '1'); fill.style.width = '100%'; }
            } else if (fill && fill.getAttribute('data-pending') === '1' && available) {
              fill.setAttribute('data-pending', '0');
              fill.style.width = '100%';
              if (alloc) alloc.textContent = hero ? 'Allocation open' : 'Available';
            }

            buildCta(card, state);
            paintWatch();
            refreshChips();
            applyFilter();

            var handle = card.getAttribute('data-handle');
            if (state === 'live' && (prev === 'coming' || prev === 'pending') && !announced[handle]) {
              announced[handle] = true;
              showToast((card.getAttribute('data-title') || 'This drop') + ' just opened for pre-order', card.getAttribute('data-url'), 'Open drop');
            }
            return true;
          }

          /* Re-check the real product when a threshold is crossed, so Coming Soon
             becomes Pre-Order Live (or Allocation Pending) without a reload. */
          var checking = {};
          function recheck(card) {
            var handle = card.getAttribute('data-handle');
            if (!handle || checking[handle]) return;
            checking[handle] = true;
            fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'products/' + handle + '.js'
              : '/products/' + handle + '.js')
              .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); })
              .then(function (data) {
                var available = !!data.available;
                var first = null;
                for (var i = 0; i < (data.variants || []).length; i++) {
                  if (data.variants[i].available) { first = data.variants[i]; break; }
                }
                /* The same drop can appear as both the hero and a grid card — keep
                   every copy of it in sync, not just the one that hit the threshold. */
                root.querySelectorAll('[data-card][data-handle="' + handle + '"]').forEach(function (twin) {
                  if (first) twin.setAttribute('data-vid', first.id);
                  applyState(twin, stateFor(twin, available), available);
                });
              })
              .catch(function () { /* leave the server-rendered state alone */ })
              .then(function () { setTimeout(function () { delete checking[handle]; }, 30000); });
          }

          /* =====================================================================
             COUNTDOWNS

             One target: `rel`, the release date, in every state. `reveal` is still
             read here, but only to decide when to re-check a Coming Soon drop with
             Shopify — it never drives the digits. Keep it that way: the card prints
             the ship date immediately above the timer, and the moment those two
             measure different things the card reads as broken.
          ===================================================================== */
          var cdCards = Array.prototype.slice.call(root.querySelectorAll('[data-card]')).filter(function (c) {
            return num(c, 'data-rel') > 0;
          });

          function pad(n) { return n < 10 ? '0' + n : '' + n; }

          function setCell(el, val) {
            if (!el) return;
            var next = String(val);
            if (el.textContent === next) return;
            el.textContent = next;
            var cell = el.parentNode;
            if (!reduce && cell && cell.classList && cell.classList.contains('llpo__cd-cell')) {
              cell.classList.remove('is-tick');
              void cell.offsetWidth;
              cell.classList.add('is-tick');
            }
          }

          function tick() {
            var now = Math.floor(Date.now() / 1000);
            cdCards.forEach(function (card) {
              var rel = num(card, 'data-rel');
              var reveal = num(card, 'data-reveal');
              var state = card.getAttribute('data-state');

              /* The DISPLAY is always the release date — one target, every state, so
                 the digits can never disagree with the date printed beside them. */
              var diff = rel - now;

              /* State promotion still turns on two thresholds, and the display no
                 longer tracks either one, so watch them directly: a Coming Soon card
                 promotes when the pre-order window opens (reveal), everything still
                 unsettled re-checks again at the release itself. */
              if (state === 'coming') {
                if (now >= reveal) recheck(card);
              } else if (state === 'pending' || state === 'live') {
                if (now >= rel) recheck(card);
              }

              var wrap = card.querySelector('[data-cd]');
              if (!wrap) return;

              if (diff < 0) diff = 0;
              var d = Math.floor(diff / 86400);
              var h = Math.floor((diff % 86400) / 3600);
              var m = Math.floor((diff % 3600) / 60);
              var sec = diff % 60;

              var mini = wrap.hasAttribute('data-mini');
              setCell(wrap.querySelector('[data-cd-d]'), mini ? d + 'd' : d);
              setCell(wrap.querySelector('[data-cd-h]'), mini ? pad(h) + 'h' : pad(h));
              setCell(wrap.querySelector('[data-cd-m]'), mini ? pad(m) + 'm' : pad(m));
              setCell(wrap.querySelector('[data-cd-s]'), pad(sec));

              wrap.setAttribute('data-urgent', diff > 0 && diff < 86400 ? '1' : '0');

              /* Only two labels left, because there is only one target: counting to
                 the release, or past it. Card copy is shorter than the hero's — it
                 sits inline with the digits rather than on its own row. */
              var lab = wrap.querySelector('[data-cd-label]');
              if (lab) {
                var set = mini ? cfg.cdMiniLabels : cfg.cdLabels;
                if (diff <= 0) lab.textContent = set.done || (mini ? 'Out now' : 'Released');
                else lab.textContent = set.release || 'Releases in';
              }
            });
          }
          if (cdCards.length) {
            tick();
            timers.push(setInterval(tick, 1000));
            /* a tab left open for hours still lands on the truth */
            document.addEventListener('visibilitychange', onVis);
          }
          function onVis() { if (!document.hidden) tick(); }

          /* =====================================================================
             PRE-ORDER ADD TO CART
          ===================================================================== */
          root.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-add]');
            if (!btn || !root.contains(btn)) return;
            e.preventDefault();
            var card = btn.closest('[data-card]');
            var id = card.getAttribute('data-vid');
            if (!id) { window.location.href = card.getAttribute('data-url'); return; }

            var props = {};
            var release = card.getAttribute('data-release');
            var state = card.getAttribute('data-state');
            if (state === 'live' && release) props['Pre-order release'] = release;

            btn.classList.add('is-busy');
            var body = { items: [{ id: Number(id), quantity: 1 }] };
            if (Object.keys(props).length) body.items[0].properties = props;

            fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(body)
            })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
              .then(function (res) {
                if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add');
                showToast(cfg.toastAdded || 'Added to your cart', cfg.cartUrl || '/cart', 'View cart');
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              })
              .catch(function (err) {
                showToast(err.message || 'Sorry, that could not be added', card.getAttribute('data-url'), 'Open drop');
                recheck(card);
              })
              .then(function () { btn.classList.remove('is-busy'); });
          });

          /* =====================================================================
             DROP SCHEDULE JUMP
          ===================================================================== */
          function railItems() {
            return Array.prototype.slice.call(root.querySelectorAll('[data-tl-jump]'));
          }

          function paintRail() {
            railItems().forEach(function (item) {
              item.setAttribute('aria-pressed', item.getAttribute('data-date') === dateFilter && dateFilter ? 'true' : 'false');
            });
          }

          /* Clearing has to happen on a tab switch: the rail belongs to the panel,
             so a date held over from another game would empty the grid silently. */
          function clearDate() {
            if (!dateFilter) return;
            dateFilter = '';
            dateLabel = '';
            paintRail();
          }

          function setDate(item) {
            var key = item.getAttribute('data-date');
            var on = key && key !== dateFilter;
            dateFilter = on ? key : '';
            dateLabel = on ? (item.querySelector('.llpo__tl-date') || {}).textContent || '' : '';
            paintRail();
            /* Counts first: a status with nothing on this date is disabled, and the
               filter drops back to All rather than showing an empty grid. */
            refreshChips();
            applyFilter();
            applySort();
            var panel = activePanel();
            var grid = panel ? panel.querySelector('[data-grid]') : null;
            if (grid) {
              grid.scrollLeft = 0;
              refreshRails();
              var r = grid.getBoundingClientRect();
              if (r.top < 0 || r.top > window.innerHeight * 0.6) {
                grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
              }
            }
            var n = panel ? panel.querySelectorAll('.llpo__card:not([hidden])').length : 0;
            say(on ? n + (n === 1 ? ' drop' : ' drops') + ' releasing ' + dateLabel : 'Showing every drop');
          }

          root.addEventListener('click', function (e) {
            var jump = e.target.closest('[data-tl-jump]');
            if (!jump || !root.contains(jump)) return;
            setDate(jump);
          });

          /* =====================================================================
             SET CHIPS
          ===================================================================== */
          var setRows = Array.prototype.slice.call(root.querySelectorAll('[data-sets-for]'));

          function activeSetRow() {
            for (var i = 0; i < setRows.length; i++) { if (!setRows[i].hidden) return setRows[i]; }
            return null;
          }
          function showSetRow(index) {
            setRows.forEach(function (row) { row.hidden = String(index) !== row.getAttribute('data-sets-for'); });
          }
          function paintSets() {
            var row = activeSetRow();
            if (!row) return;
            row.querySelectorAll('[data-set]').forEach(function (b) {
              b.setAttribute('aria-pressed', b.getAttribute('data-set') === setFilter ? 'true' : 'false');
            });
          }
          /* Dates with nothing in the chosen set leave the schedule, so the rail
             never offers a day that would empty the grid. If the chosen date is
             one of them, it is let go. */
          function syncRailToSet() {
            var panel = activePanel();
            if (!panel) return;
            var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-card]')).filter(inSet);
            var dates = {};
            cards.forEach(function (c) { dates[c.getAttribute('data-relkey')] = (dates[c.getAttribute('data-relkey')] || 0) + 1; });
            panel.querySelectorAll('[data-tl-jump]').forEach(function (item) {
              var n = dates[item.getAttribute('data-date')] || 0;
              item.hidden = n === 0;
              var name = item.querySelector('.llpo__tl-name');
              if (!name) return;
              if (!name.hasAttribute('data-orig')) name.setAttribute('data-orig', name.textContent);
              var all = parseInt(name.getAttribute('data-count'), 10) || 0;
              name.textContent = (setFilter && n && n !== all) ? (n === 1 ? '1 drop' : n + ' drops') : name.getAttribute('data-orig');
            });
            if (dateFilter && !dates[dateFilter]) { dateFilter = ''; dateLabel = ''; paintRail(); }
          }
          /* Every panel's schedule back to how it was rendered. Run on clear, not
             only for the active panel: a tab switch clears the set after the new
             panel is already showing, and the old one would keep its trimmed rail. */
          function restoreRails() {
            root.querySelectorAll('[data-tl-jump]').forEach(function (item) {
              item.hidden = false;
              var name = item.querySelector('.llpo__tl-name');
              if (name && name.hasAttribute('data-orig')) name.textContent = name.getAttribute('data-orig');
            });
          }
          /* "View every drop" follows the set: the collection filtered to that
             tag, which is a real Shopify URL and works with scripts off too. Only
             when the link is the collection itself, not a merchant's own link. */
          function syncViewAll() {
            var panel = activePanel();
            if (!panel) return;
            var a = panel.querySelector('[data-view-all][data-tag-link]');
            if (!a) return;
            var base = a.getAttribute('data-base') || a.getAttribute('href');
            a.setAttribute('href', setFilter ? base.replace(/\/$/, '') + '/' + encodeURIComponent(setFilter) : base);
            var txt = a.querySelector('.llpo__btn-txt');
            if (txt) {
              if (!txt.hasAttribute('data-default')) txt.setAttribute('data-default', txt.textContent);
              txt.textContent = setFilter ? 'View all ' + setLabel : txt.getAttribute('data-default');
            }
          }
          function clearSet() {
            if (!setFilter) return;
            setFilter = '';
            setLabel = '';
            paintSets();
            restoreRails();
            root.querySelectorAll('[data-sets-for] [data-set]').forEach(function (b) {
              b.setAttribute('aria-pressed', b.getAttribute('data-set') === '' ? 'true' : 'false');
            });
          }
          function setSet(btn) {
            var key = btn.getAttribute('data-set') || '';
            setFilter = key && key !== setFilter ? key : '';
            setLabel = setFilter ? (btn.getAttribute('data-set-label') || '') : '';
            paintSets();
            syncRailToSet();
            refreshChips();
            applyFilter();
            applySort();
            syncViewAll();
            var panel = activePanel();
            var grid = panel ? panel.querySelector('[data-grid]') : null;
            if (grid) grid.scrollLeft = 0;
            refreshRails();
            var n = panel ? panel.querySelectorAll('[data-card]:not([hidden])').length : 0;
            say(setFilter ? n + (n === 1 ? ' drop' : ' drops') + ' in ' + setLabel : 'Showing every set');
          }

          root.addEventListener('click', function (e) {
            var chip = e.target.closest('[data-set]');
            if (!chip || !root.contains(chip) || !chip.closest('[data-sets-for]')) return;
            setSet(chip);
          });

          /* =====================================================================
             DROP SCHEDULE RAIL
             Arrows and the edge fade only appear when the rail actually overflows.
          ===================================================================== */
          var railUpdaters = [];
          function refreshRails() { railUpdaters.forEach(function (f) { f(); }); }

          root.querySelectorAll('[data-rail-wrap]').forEach(function (wrap) {
            var rail = wrap.querySelector('[data-rail]');
            var nav = wrap.querySelector('[data-rail-nav]');
            var prev = wrap.querySelector('[data-rail-prev]');
            var next = wrap.querySelector('[data-rail-next]');
            if (!rail) return;

            function update() {
              var max = rail.scrollWidth - rail.clientWidth;
              /* A panel that is hidden measures zero — leave it alone until shown. */
              if (!rail.clientWidth) return;
              if (max <= 4) {
                rail.setAttribute('data-edge', 'none');
                if (nav) nav.hidden = true;
                return;
              }
              if (nav) nav.hidden = false;
              var x = rail.scrollLeft;
              var atStart = x <= 2;
              var atEnd = x >= max - 2;
              rail.setAttribute('data-edge', atStart ? 'right' : (atEnd ? 'left' : 'both'));
              if (prev) prev.disabled = atStart;
              if (next) next.disabled = atEnd;
            }

            rail.addEventListener('scroll', update, { passive: true });

            [[prev, -1], [next, 1]].forEach(function (pair) {
              if (!pair[0]) return;
              pair[0].addEventListener('click', function () {
                rail.scrollBy({
                  left: pair[1] * Math.max(180, Math.round(rail.clientWidth * 0.8)),
                  behavior: reduce ? 'auto' : 'smooth'
                });
              });
            });

            if ('ResizeObserver' in window) {
              var ro = new ResizeObserver(update);
              ro.observe(rail);
              observers.push(ro);
            }
            railUpdaters.push(update);
            update();
          });

          /* =====================================================================
             DISCORD LIVE COUNT
          ===================================================================== */
          (function () {
            var bar = root.querySelector('[data-llpo-discord]');
            if (!bar) return;
            var out = bar.querySelector('[data-disc-online]');
            var id = bar.getAttribute('data-server-id');
            fetch('https://discord.com/api/guilds/' + id + '/widget.json')
              .then(function (r) { if (!r.ok) throw new Error('widget off'); return r.json(); })
              .then(function (d) {
                var n = typeof d.presence_count === 'number' ? d.presence_count : null;
                if (out) out.textContent = n === null ? 'Live' : n.toLocaleString();
              })
              .catch(function () { if (out) out.textContent = 'Live'; });
          })();

          /* Ordered last on purpose: activate() runs the filter and sort, so it must
             not fire until `filter`, `chips` and the sort select all exist. */
          if (tabs.length) activate(0, false);
          paintWatch();
          refreshChips();
          applyFilter();
          applySort();
          refreshRails();

          /* =====================================================================
             THEME EDITOR TEARDOWN
          ===================================================================== */
          root.llpoDestroy = function () {
            timers.forEach(clearInterval);
            observers.forEach(function (o) { o.disconnect(); });
            document.removeEventListener('visibilitychange', onVis);
            document.removeEventListener('ll:watchlist:change', syncWatchFromStore);
            window.removeEventListener('storage', onWatchStorage);
            clearTimeout(toastTimer);
            root.dataset.llpoReady = '';
          };
        }

        function find() { return document.querySelector('[data-llpo-root][data-section-id="' + ROOT_ID + '"]'); }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { boot(find()); });
        } else {
          boot(find());
        }

        document.addEventListener('shopify:section:load', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          boot(find());
        });
        document.addEventListener('shopify:section:unload', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          var el = find();
          if (el && el.llpoDestroy) el.llpoDestroy();
        });
        document.addEventListener('shopify:section:select', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          var el = find();
          if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-llpo-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();

  /* ---- block 2 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      /* Slide affordance: an edge fade that follows real scroll position, plus a
           progress readout so "there is more" is unmistakable. Additive only - it
           reads scroll offsets and writes one attribute. */
        var SELS = [".llpo__grid", ".llpo__timeline"];
        var LABEL = "Swipe drops";
        var root = document.getElementById('shopify-section-' + ROOT_ID);
        if (!root) return;

        var mq = window.matchMedia('(max-width: 700px)');

        function railList() {
          var out = [];
          for (var i = 0; i < SELS.length; i++) {
            var found = root.querySelectorAll(SELS[i]);
            for (var j = 0; j < found.length; j++) out.push(found[j]);
          }
          return out;
        }

        function barFor(el) {
          var b = el.nextElementSibling;
          if (b && b.className === 'll-swipebar') return b;
          b = document.createElement('span');
          b.className = 'll-swipebar';
          b.setAttribute('aria-hidden', 'true');
          var lab = document.createElement('b');
          lab.textContent = LABEL;
          var track = document.createElement('u');
          track.appendChild(document.createElement('i'));
          b.appendChild(lab);
          b.appendChild(track);
          if (el.parentNode) el.parentNode.insertBefore(b, el.nextSibling);
          return b;
        }

        function sync(el) {
          var bar = barFor(el);
          var over = el.scrollWidth - el.clientWidth;
          if (!mq.matches || over <= 4) {
            el.removeAttribute('data-swipe');
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var left = el.scrollLeft > 4;
          var right = el.scrollLeft < over - 4;
          el.setAttribute('data-swipe', left && right ? 'both' : (left ? 'left' : 'right'));

          var w = Math.max(18, (el.clientWidth / el.scrollWidth) * 100);
          var frac = el.scrollLeft / over;
          var thumb = bar.querySelector('i');
          thumb.style.width = w.toFixed(1) + '%';
          thumb.style.transform = 'translateX(' + (((100 - w) / w) * 100 * frac).toFixed(1) + '%)';
        }

        function boot() {
          railList().forEach(function (el) {
            if (el.__llSwipe) { sync(el); return; }
            el.__llSwipe = 1;
            var raf = 0;
            el.addEventListener('scroll', function () {
              if (raf) return;
              raf = requestAnimationFrame(function () { raf = 0; sync(el); });
            }, { passive: true });
            if (window.ResizeObserver) new ResizeObserver(function () { sync(el); }).observe(el);
            sync(el);
          });
        }

        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
        else boot();
        window.addEventListener('resize', boot);
        window.addEventListener('load', boot);
        document.addEventListener('shopify:section:load', boot);
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-llpo-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();
})();
